// Mobile collection filter: open helper + accordion delegation.
// Drawer markup lives OUTSIDE #CollectionProductGrid (see main-collection.liquid) so
// (1) AJAX innerHTML replace does not destroy it, (2) fixed positioning is not trapped
// by ancestors with transform (mobile slideout translateX rules).
// Theme WAU.Slideout uses slideout--active / slideout--close — do not fight it with
// is-open/active or inline transform; that breaks overlay teardown → black screen.
(function () {
  if (window.__mobileFilterDrawerFallbackBound) return;
  window.__mobileFilterDrawerFallbackBound = true;

  var BODY_FLAG = 'data-joy-collection-filter-open';

  var markFilterDrawerOpen = function () {
    document.body.setAttribute(BODY_FLAG, 'true');
  };

  var markFilterDrawerClosed = function () {
    document.body.removeAttribute(BODY_FLAG);
  };

  /** Drop inline overrides so WAU + theme CSS control the mask again. */
  var clearSlideoutOverlayInline = function () {
    var overlay = document.querySelector('.js-slideout-overlay');
    if (!overlay) return;
    overlay.style.removeProperty('opacity');
    overlay.style.removeProperty('visibility');
    overlay.style.removeProperty('display');
    overlay.style.removeProperty('z-index');
    overlay.style.removeProperty('pointer-events');
  };

  /** Last resort if theme left the dimmer visible after close. */
  var forceOverlayHidden = function () {
    var overlay = document.querySelector('.js-slideout-overlay');
    if (!overlay) return;
    overlay.style.opacity = '0';
    overlay.style.visibility = 'hidden';
    overlay.style.pointerEvents = 'none';
  };

  var filterDrawerIsOpen = function () {
    var d = document.getElementById('slideout-collection-filters');
    if (!d) return false;
    if (d.getAttribute('aria-hidden') === 'false') return true;
    if (d.classList.contains('slideout--active')) return true;
    return false;
  };

  var afterCloseCleanup = function () {
    window.setTimeout(function () {
      if (filterDrawerIsOpen()) return;
      markFilterDrawerClosed();
      clearSlideoutOverlayInline();
      var o = document.querySelector('.js-slideout-overlay');
      if (o) {
        var op = parseFloat(window.getComputedStyle(o).opacity || '0');
        if (op > 0.05) {
          forceOverlayHidden();
        }
      }
    }, 350);
  };

  document.addEventListener(
    'click',
    function (e) {
      if (window.innerWidth >= 1024) return;
      var closeBtn = e.target && e.target.closest && e.target.closest('.js-slideout-close');
      if (!closeBtn) return;
      var drawer = document.getElementById('slideout-collection-filters');
      if (!drawer || !drawer.contains(closeBtn)) return;
      afterCloseCleanup();
    },
    false
  );

  document.addEventListener(
    'click',
    function (e) {
      if (window.innerWidth >= 1024) return;
      var t = e.target;
      if (t && t.classList && t.classList.contains('js-slideout-overlay')) {
        afterCloseCleanup();
      }
    },
    false
  );

  try {
    if (window.Events && typeof window.Events.on === 'function') {
      window.Events.on('slideout:close:collection-filters', function () {
        markFilterDrawerClosed();
        clearSlideoutOverlayInline();
      });
      window.Events.on('slideout:closed:collection-filters', function () {
        markFilterDrawerClosed();
        clearSlideoutOverlayInline();
      });
    }
  } catch (_) { /* no-op */ }

  /** Stuck overlay from older theme state / partial close */
  var recoverStaleOverlay = function () {
    if (filterDrawerIsOpen()) return;
    markFilterDrawerClosed();
    clearSlideoutOverlayInline();
    var o = document.querySelector('.js-slideout-overlay');
    if (o && parseFloat(window.getComputedStyle(o).opacity || '0') > 0.05) {
      forceOverlayHidden();
    }
  };
  window.addEventListener('pageshow', recoverStaleOverlay);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', recoverStaleOverlay);
  } else {
    recoverStaleOverlay();
  }

  var initFilterDrawerPriceBindings = function (drawer) {
    if (!drawer || window.innerWidth >= 1024) return;
    var filterMenu = drawer.querySelector('.js-mobile-menu[data-menu-handle="filter"]');
    if (!filterMenu) return;

    if (filterMenu.dataset.priceAutoApplyBound !== 'true') {
      filterMenu.dataset.priceAutoApplyBound = 'true';
      var priceAutoApplyTimer;
      var triggerPriceApply = function () {
        clearTimeout(priceAutoApplyTimer);
        priceAutoApplyTimer = setTimeout(function () {
          var applyBtn = filterMenu.querySelector(
            '.slide-nav__second-level--wrapper[data-link-parent="price"] .js-update-price'
          );
          if (applyBtn) applyBtn.click();
        }, 220);
      };
      filterMenu.addEventListener(
        'change',
        function (ev) {
          var target = ev.target;
          if (!target || !target.closest) return;
          if (target.closest('.slide-nav__second-level--wrapper[data-link-parent="price"]')) {
            if (target.matches('input[type="range"], input[type="number"]')) {
              triggerPriceApply();
            }
          }
        },
        true
      );
    }

    if (filterMenu.dataset.priceSyncBound !== 'true') {
      filterMenu.dataset.priceSyncBound = 'true';
      var updatePriceSliderFill = function (pricePanel) {
        if (!pricePanel) return;
        var ranges = pricePanel.querySelectorAll('.filter-range__slider--input');
        var wrapper = pricePanel.querySelector('.filter-range__slider--wrapper');
        if (ranges.length < 2 || !wrapper) return;
        var minRange = ranges[0];
        var maxRange = ranges[1];
        var floor = parseFloat(minRange.min || 0);
        var ceil = parseFloat(minRange.max || 100);
        if (!isFinite(ceil) || ceil <= floor) ceil = floor + 1;
        var minValue = parseFloat(minRange.value || floor);
        var maxValue = parseFloat(maxRange.value || ceil);
        var minPct = ((minValue - floor) / (ceil - floor)) * 100;
        var maxPct = ((maxValue - floor) / (ceil - floor)) * 100;
        minPct = Math.max(0, Math.min(100, minPct));
        maxPct = Math.max(0, Math.min(100, maxPct));
        wrapper.style.setProperty('--price-min-pct', minPct + '%');
        wrapper.style.setProperty('--price-max-pct', maxPct + '%');
      };

      filterMenu.addEventListener(
        'input',
        function (ev) {
          var target = ev.target;
          if (!target || !target.matches || !target.matches('input[type="range"]')) return;
          var pricePanel = target.closest('.slide-nav__second-level--wrapper[data-link-parent="price"]');
          if (!pricePanel) return;
          var ranges = pricePanel.querySelectorAll('.filter-range__slider--input');
          var fields = pricePanel.querySelectorAll('.js-filter-range-input');
          if (ranges.length < 2 || fields.length < 2) return;
          var min = Math.round(parseFloat(ranges[0].value) || 0);
          var max = Math.round(parseFloat(ranges[1].value) || 0);
          fields[0].value = min;
          fields[1].value = max;
          updatePriceSliderFill(pricePanel);
        },
        true
      );

      var initPricePanel = filterMenu.querySelector('.slide-nav__second-level--wrapper[data-link-parent="price"]');
      if (initPricePanel) {
        updatePriceSliderFill(initPricePanel);
        var initRanges = initPricePanel.querySelectorAll('.filter-range__slider--input');
        initRanges.forEach(function (rangeInput) {
          var sync = function () {
            updatePriceSliderFill(initPricePanel);
          };
          rangeInput.addEventListener('input', sync, { passive: true });
          rangeInput.addEventListener('change', sync, { passive: true });
          var bringToFront = function () {
            initRanges.forEach(function (item) {
              item.style.zIndex = '2';
            });
            rangeInput.style.zIndex = '3';
          };
          rangeInput.addEventListener('pointerdown', bringToFront, { passive: true });
          rangeInput.addEventListener('touchstart', bringToFront, { passive: true });
          rangeInput.addEventListener('mousedown', bringToFront);
        });
      }
    }
  };

  var syncFilterDrawerMenus = function (drawer) {
    if (!drawer || window.innerWidth >= 1024) return;
    markFilterDrawerOpen();

    var menuButtons = drawer.querySelectorAll('.filter-drawer__menu-toggle .js-menu-toggle');
    var mobileMenus = drawer.querySelectorAll('.filter-drawer__mobile-menus .js-mobile-menu');
    menuButtons.forEach(function (btn) {
      btn.classList.toggle('active--menu', btn.getAttribute('data-toggle-menu') === 'filter');
      if (btn.getAttribute('data-toggle-menu') === 'filter') {
        btn.textContent = 'Filter';
      }
    });
    mobileMenus.forEach(function (menu) {
      var isFilter = menu.getAttribute('data-menu-handle') === 'filter';
      menu.classList.toggle('active--menu', isFilter);
      if (isFilter) {
        menu.style.removeProperty('display');
      }
      var firstLevels = menu.querySelectorAll('.slide-nav__first-level--wrapper');
      firstLevels.forEach(function (wrapper) {
        wrapper.classList.toggle('nav-slide--active', isFilter);
      });
    });
    initFilterDrawerPriceBindings(drawer);
  };

  try {
    if (window.Events && typeof window.Events.on === 'function') {
      window.Events.on('slideout:open:collection-filters', function () {
        var drawer = document.querySelector('.slideout[data-wau-slideout="collection-filters"]');
        syncFilterDrawerMenus(drawer);
      });
    }
  } catch (_) { /* no-op */ }

  document.addEventListener(
    'click',
    function (ev) {
      if (window.innerWidth >= 1024) return;
      var btn = ev.target && ev.target.closest
        ? ev.target.closest('.slide-nav__first-level--button[data-link-trigger]')
        : null;
      if (!btn) return;
      var drawer = document.getElementById('slideout-collection-filters');
      if (!drawer || !drawer.contains(btn)) return;

      ev.preventDefault();
      ev.stopPropagation();

      var filterMenu = drawer.querySelector('.js-mobile-menu[data-menu-handle="filter"]');
      if (!filterMenu) return;

      initFilterDrawerPriceBindings(drawer);

      var secondLevelWrappers = filterMenu.querySelectorAll('.slide-nav__second-level--wrapper');
      var triggerButtons = filterMenu.querySelectorAll('.slide-nav__first-level--button[data-link-trigger]');
      var trigger = btn.getAttribute('data-link-trigger');
      if (!trigger) return;
      var panel = filterMenu.querySelector('.slide-nav__second-level--wrapper[data-link-parent="' + trigger + '"]');
      if (!panel) return;
      var firstLevelItem = btn.closest('.slide-nav__first-level--item');

      var willOpen = !panel.classList.contains('is-open-accordion');
      secondLevelWrappers.forEach(function (item) {
        item.classList.remove('is-open-accordion');
      });
      triggerButtons.forEach(function (item) {
        item.classList.remove('is-open-accordion');
      });

      if (willOpen) {
        if (firstLevelItem && firstLevelItem.parentNode) {
          firstLevelItem.parentNode.insertBefore(panel, firstLevelItem.nextSibling);
        }
        panel.classList.add('is-open-accordion');
        btn.classList.add('is-open-accordion');
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target && event.target.closest
        ? event.target.closest('.js-filter-toggle.js-slideout-open')
        : null;
      if (!trigger || window.innerWidth >= 1024) return;

      event.preventDefault();
      event.stopPropagation();

      if (window.WAU && window.WAU.Slideout) {
        window.WAU.Slideout.init('collection-filters');
        if (typeof window.WAU.Slideout._openByName === 'function') {
          window.WAU.Slideout._openByName('collection-filters');
        }
      }

      var drawer = document.querySelector('.slideout[data-wau-slideout="collection-filters"]');
      if (drawer) {
        syncFilterDrawerMenus(drawer);
      }
    },
    true
  );
})();
